
import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'

import BlueButton from '../Atomic/BlueButton.vue'
import GreenButton from '../Atomic/GreenButton.vue'
import RedButton from '../Atomic/RedButton.vue'
import CardTitle from '../Atomic/CardTitle.vue'

import AccountForm from './AccountForm.vue'

import { Extra } from '../../models/user'
import ExtrasService from '../../services/ExtrasService'
import OrganisationsService from '../../services/OrganisationsService'

import { INotificationService } from '../../services/NotificationService'
import ErrorHandler from '@/services/ErrorHandlerService'
import { Organisation } from '@/models/organisation'

import moment from 'moment'
import ProgressLinear from '@/components/Atomic/ProgressLinear.vue'

@Component({
  components: {
    AccountForm,
    BlueButton,
    GreenButton,
    RedButton,
    CardTitle,
    ProgressLinear,
  },
})
export default class CreateExtra extends Vue {

  @Prop(Function) public readonly onClose!: () => void
  @Prop() private readonly extras!: Extra[]
  private dialog: boolean = false
  private isPending: boolean = false
  private account: Extra = {authority: null, department: null, entity: null, unit: null} as Extra

  private $notificationService!: INotificationService
  private errorHandler = new ErrorHandler()

  public show() {
      this.dialog = true
    }

  private mounted() {
    this.setDefaultBirthDate()
  }

  private async create() {
    this.isPending = true
    const validated = await this.$validator.validateAll()
    if (validated) {
      try {
        await ExtrasService.create(this.account)
        this.$notificationService.success(
          this.$t('EXTRAS.CreationSuccess').toString(),
        )
        this.hide()
      } catch (error: any) {
        this.errorHandler.handle(this, error.response.data.code, true)
      }
    }
    this.isPending = false
  }

  private setDefaultBirthDate() {
    if (this.account.date_naissance === undefined) {
      this.account.date_naissance = moment(new Date()).format('YYYY-MM-DD')
    }
  }

  private changePendingStatus(status: boolean) {
    this.isPending = status
  }

  private hide() {
    this.account = {authority: null, department: null, entity: null, unit: null} as Extra
    this.setDefaultBirthDate()
    this.$validator.reset()
    this.onClose()
    this.dialog = false
  }
 }
